import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_rootLayout/companies')({
  preload: false,
  beforeLoad: ({ context: { permissions } }) => {
    if (
      !hasPermission(permissions, {
        permission: 'ADDRESSBOOK_COMPANIES',
        action: 'READ',
      })
    ) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true,
      });
    }
  },
});
